import component from './component'

export default {
    path: '/',
    name: 'login',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/account/login/index.js